import AppContext from "Contexts/AppContext";
import UserContext from "Contexts/User";
import React, { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import useSound from "use-sound";
import { Pill, RoundPill } from "./ScrollVote.styles";
import VoteAndSpinLeft from "./VoteAndSpinLeft";
// @ts-ignore
import VoteBoosterSound from '../../assets/sounds/VoteBooster.mp3';
import { findClosestValue } from "common/utils/helper";

type VoteAndPowerProps = {
  votesLeft?: number | string;
  powerX?: number | string;
  onClickVotes?: () => void;
  className?: string;
  disabledVotes?: boolean;
  disabledPower?: boolean;
  customPowerValue?: string; // New prop for custom power value
};

const Bar = styled.div<{ $voteNumber?: number }>`
  position: absolute;
  margin: 0 auto;
  z-index: 90;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0;
  // width: ${window.innerWidth > 768 ? "calc(100% - 45%)" : "100%"};
  padding: 8px 16px;
  bottom: ${window.innerWidth > 768 ? "25px" : "15px"};
`;



const VoteAndPower: React.FC<VoteAndPowerProps> = ({
  className,
  disabledPower,
  customPowerValue, // Destructure the new prop
}) => {
  const { userInfo } = useContext(UserContext);
  const { boosterVote, setBoosterVote, boosterButtonBlink, setBoosterButtonBlink, currentIndex,
    setCurrentIndex,
    boosterValueArray,
  } = useContext(AppContext);
  const [handleSoundClick] = useSound(VoteBoosterSound, { interrupt: true, html5: true });
  const [voteNumber, setVoteNumber] = useState(0);
  const [debounceAnimation, setDebounceAnimation] = useState(false);

  useEffect(() => {
    const voteValue = Number(userInfo?.voteValue || 0);
    const extraVote = Number(userInfo?.rewardStatistics?.extraVote || 0);
    const totalVotes = voteValue + extraVote;

    // Only set if it's a valid finite number
    if (Number.isFinite(totalVotes) && totalVotes >= 0) {
      setVoteNumber(totalVotes);
      findClosestValue(boosterValueArray, totalVotes, 10, setCurrentIndex, setBoosterVote);
    } else {
      setVoteNumber(0);
    }
  }, [userInfo?.voteValue, userInfo?.rewardStatistics?.extraVote, boosterValueArray, setCurrentIndex, setBoosterVote]);

  const aniRef = useRef<any>();

  useEffect(() => {
    if (debounceAnimation) {
      clearTimeout(aniRef.current);


      aniRef.current = setTimeout(() => {
        setDebounceAnimation(false)
      }, 300);

      // debounceAnimation, setDebounceAnimation

      return () => clearTimeout(aniRef.current);
    }

  }, [debounceAnimation])
  const handleSelect = () => {
    //   setSelectedValue(text);
    // setIsOpen(false); // Close the dropdown after selecting an option      
    setBoosterButtonBlink(false)
    setDebounceAnimation(true)
    setCurrentIndex((prevIndex: any) => (prevIndex + 1) % boosterValueArray?.length);
    setBoosterVote(boosterValueArray[(currentIndex + 1) % boosterValueArray?.length])
    handleSoundClick()

  };

  // Determine which power value to display
  // Add safety checks for array access
  const safeCurrentIndex = currentIndex >= 0 && currentIndex < boosterValueArray?.length ? currentIndex : 0;
  const arrayValue = boosterValueArray?.[safeCurrentIndex];

  let displayPowerValue: any = customPowerValue !== ""
    ? customPowerValue
    : (arrayValue && arrayValue > 1 ? arrayValue : boosterVote);

  // Ensure displayPowerValue is valid and finite
  if (!Number.isFinite(Number(displayPowerValue)) || Number(displayPowerValue) <= 0) {
    displayPowerValue = 1;
  }

  // Check if voteNumber is valid and finite
  const isValidVoteNumber = Number.isFinite(voteNumber) && voteNumber > 0;

  // Check if displayPowerValue is valid
  const isValidPowerValue = Number.isFinite(Number(displayPowerValue)) && Number(displayPowerValue) > 0;

  return (
    <div className="d-flex justify-content-center">
      <Bar className={className} $voteNumber={voteNumber} >
        {/* <VoteAndSpinLeft/> */}

        {isValidVoteNumber && isValidPowerValue && (
          <RoundPill
            aria-label="power-multiplier"
            disabled={disabledPower}
            $disabled={!!disabledPower}
            $bgStart="#8A4AFF"
            $bgEnd="#6C2FE5"
            onClick={(e) => {
              e.stopPropagation();
              handleSelect();
            }}
          >
            <span className="power-value">X{displayPowerValue}</span>
            <span className="power-label">Power</span>
          </RoundPill>
        )}
      </Bar>
    </div>
  );
};

export default VoteAndPower;
